<template>
	<div class="step1">
		<div class="step1__content">
			<p class="step1__header">What Kind of Appointment are We Seeing You For?</p>
			<div class="step1__options">
        <button class="step1__option"
                :class="{'is-selected': type === 'FreeConsultation'}"
                @click="selectAppointmentType('FreeConsultation')">
          <img class="step1__img" 
               src="https://midwest-beltone-com-iframes-prod.azurewebsites.net/images/online-scheduling-new-patient.jpg"
               alt="New Patient"/>
          <span class="step1__text">
            <p class="step1__text-header">New Patient</p>
            <p class="step1__text-subheader">FREE CONSULTATION | 90 MIN</p>
          </span>
        </button>
        <button class="step1__option"
                :class="{'is-selected': type === 'FollowUp'}"
                @click="selectAppointmentType('FollowUp')">
          <img class="step1__img" 
               src="https://midwest-beltone-com-iframes-prod.azurewebsites.net/images/online-scheduling-current-patient.jpg" 
               alt="Current Patient"/>
          <span class="step1__text">
            <p class="step1__text-header">Current Patient</p>
            <p class="step1__text-subheader">FOLLOW-UP | 30 MIN</p>
          </span>
        </button>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex';
import Services from '../../mixins/services';

export default {
	mixins: [Services],
	data() {
		return {
			type: null,
		}
	},
	methods: {
    ...mapMutations('OnlineScheduling', { setStateValue: 'setStateValue' }),
    selectAppointmentType(type) {
      this.type = type;
      this.nextStep();
    },
		nextStep() {
        if (this.type !== null) {
          this.setStateValue({ key: 'appointmentType', value: this.type });
          this.setStateValue({ key: 'step', value: 2 });
        }
		},
	}
}
</script>
